export const WHITE = "#efe9ea";
export const GRAY = "#707070";
export const GOLD = "#CECE84";
export const BLUE = "#2F6DFB";
export const VIOLET = "#7345F6";
export const CYAN = "#0a99bc";
export const PINK = "#ff7bac";
export const GREEN = "#41B167";
export const ORANGE = "#ECAF69";
export const RED = "#EC326A";
export const LIGHT_GREEN = "#01d0bb";
export const SLATE_BLUE = "#A3AAC7";

export const DARK_BLUE = "#37477C";
export const DARK_GREY = "#566573";
export const LIGHT_BLUE = "#9DB5D1";

export const DATA_ROBUSTNESS_SCORE_COLORS = [
  "#EF5E33",
  "#EFA733",
  "#EFE133",
  "#B5EF33",
  "#5FEF31",
] as const;

export const CHART_COLORS: string[] = [
  "#33A02C",
  "#E58BFB",
  "#608EFF",
  "#DB4C96",
  "#FFB800",
  "#00CFC1",
  "#6E1FAE",
  "#FA7E61",
  "#B2DF8A",
  "#F33F3F",
  "#3F46F3",
  "#1DD10D",
  "#FB9A99",
  "#F3EC3F",
  "#1F78B4",
  "#FF7FA3",
  "#3FF3BD",
  "#B93FF3",
  "#4215C5",
  "#F33FCC",
];

export const SENTIMENT_COLORS = {
  positive: "#0035CF",
  neutral: "#FF8D5C",
  negative: "#FF4451",
};

export default [
  GOLD,
  BLUE,
  VIOLET,
  CYAN,
  PINK,
  GREEN,
  ORANGE,
  RED,
  LIGHT_GREEN,
  LIGHT_BLUE,
] as const;
